import { CandidatePriority } from '@pflegia/types/api';

import { PayloadsType } from '../utils/types';

export const Name = 'email_sender_name_segment_test';

export const PossiblePayloads = ['control', 'test'] as const;

export type PayloadType = (typeof PossiblePayloads)[number];

export type VariantType = PayloadType;

export type EmailSenderCandidateSegment = 'A' | 'B' | 'D';

export const DefaultSenderName = 'Lisa Steinmann von Pflegia';

/* eslint-disable id-length */
export const DefaultSenderNamesBySegment: Record<EmailSenderCandidateSegment, string> = {
  A: 'Lisa Steinmann, Ihre Karriereberaterin',
  B: 'Lisa Steinmann | Neue Stelle für Sie',
  D: 'Lisa Steinmann | Jobs für Pflegehelfer',
};
/* eslint-enable id-length */

export const Payloads: PayloadsType<PayloadType, VariantType> = {
  control: 'control',
  test: 'test',
};

const SEGMENT_BY_PRIORITY: Partial<Record<CandidatePriority, EmailSenderCandidateSegment>> = {
  [CandidatePriority.A]: 'A',
  [CandidatePriority.B1]: 'B',
  [CandidatePriority.B2]: 'B',
  [CandidatePriority.B3]: 'B',
  [CandidatePriority.D1]: 'D',
  [CandidatePriority.D2]: 'D',
  [CandidatePriority.D3]: 'D',
};

export const getSegmentByPriority = (priority?: CandidatePriority | null): EmailSenderCandidateSegment | null =>
  (priority ? SEGMENT_BY_PRIORITY[priority] : null) ?? null;

export const getVariant = (priority?: CandidatePriority | null, payload?: PayloadType | null): PayloadType =>
  getSegmentByPriority(priority) && payload === Payloads.test ? Payloads.test : Payloads.control;

export const getSenderName = (
  priority: CandidatePriority | null | undefined,
  senderNamesBySegment: Record<EmailSenderCandidateSegment, string>,
): string | null => {
  const segment = getSegmentByPriority(priority);
  return segment ? senderNamesBySegment[segment] : null;
};

export const getTrackingProperties = (priority?: CandidatePriority | null, payload?: PayloadType | null) => {
  const emailVariant = getVariant(priority, payload);
  return {
    emailVariant,
    // eslint-disable-next-line eslint-compat/camelcase
    sender_name_variant: emailVariant,
    // eslint-disable-next-line eslint-compat/camelcase
    ...(priority ? { candidate_priority: priority } : {}),
  };
};
